import { BehaviorSubject } from 'rxjs';
import { Operation } from '../base/operation';

export class SaveOperation extends Operation {
  constructor(
    operations: BehaviorSubject<SaveOperation[]>,
    completeAfterIdleTimeout: number = null
  ) {
    super(operations);
    this.deleteTimeoutAfterComplete = 3000;
    this.deleteTimeoutAfterFail = 10000;
    this.minDelayFromProcessingToComplete = 300;
    this.failAfterIdleTimeout = 1200000;

    if (completeAfterIdleTimeout) {
      this.deleteTimer = setTimeout(() => this.complete(), completeAfterIdleTimeout);
    }
  }
}
